
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"95","height":"95","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M48 70.992c-12.381 0-24.023-4.821-32.78-13.577l-7.7-7.7a2.956 2.956 0 010-4.179l7.7-7.7C23.976 29.08 35.614 24.26 48 24.26c12.386 0 24.023 4.82 32.78 13.576l7.7 7.7a2.956 2.956 0 010 4.179l-7.7 7.7C72.025 66.171 60.387 70.992 48 70.992zM13.785 47.625l5.61 5.61c7.642 7.642 17.797 11.85 28.606 11.85 10.809 0 20.964-4.208 28.605-11.85l5.61-5.61-5.61-5.61C68.965 34.372 58.81 30.164 48 30.164c-10.81 0-20.964 4.208-28.605 11.85l-5.611 5.61zM48 59.438c-6.515 0-11.813-5.298-11.813-11.813 0-6.515 5.298-11.813 11.813-11.813 6.515 0 11.813 5.298 11.813 11.813 0 6.515-5.298 11.813-11.813 11.813zm0-17.72a5.914 5.914 0 00-5.906 5.907A5.914 5.914 0 0048 53.531a5.914 5.914 0 005.906-5.906A5.914 5.914 0 0048 41.719zm0-20.671a2.952 2.952 0 01-2.953-2.953v-8.86a2.952 2.952 0 115.906 0v8.86A2.952 2.952 0 0148 21.047zm-13.075-.535a2.954 2.954 0 00.727-4.113L30.57 9.142a2.954 2.954 0 00-4.84 3.385l5.084 7.257a2.95 2.95 0 004.112.724v.004zm30.196-.728l5.083-7.257a2.95 2.95 0 00-.727-4.112 2.95 2.95 0 00-4.112.727L60.282 16.4a2.95 2.95 0 00.727 4.113 2.923 2.923 0 001.69.535c.93 0 1.85-.436 2.422-1.259v-.004zM50.954 86.012v-8.86a2.952 2.952 0 10-5.906 0v8.86a2.952 2.952 0 105.906 0zm-20.38.092l5.083-7.257a2.95 2.95 0 00-.727-4.113 2.952 2.952 0 00-4.112.728l-5.083 7.257a2.95 2.95 0 00.727 4.112 2.924 2.924 0 001.69.535c.93 0 1.85-.435 2.422-1.258v-.004zm38.904.727a2.954 2.954 0 00.728-4.112l-5.084-7.257a2.954 2.954 0 00-4.84 3.385l5.084 7.257a2.95 2.95 0 004.112.723v.004z","fill":"#fff"}})])
          )
        }
      }
    